import gql from 'graphql-tag';

// TODO This query is used in two places, move it to global queries folder and rename it
export const AssetBuildingNameQuery = gql`
	query AssetBuildingNameQuery($objectId: [UUID]) {
		buildings(buildingsId: $objectId) {
			name
		}
	}
`;

export const AssetRoomQuery = gql`
	query AssetRoomQuery($roomId: UUID!) {
		sensors(roomId: $roomId) {
			id
			name
			sensorType
			contentType
		}
	}
`;

export const AssetSensorQuery = gql`
	query AssetSensorQuery($sensorId: UUID!) {
		sensors(sensorId: $sensorId) {
			id
			name
			sensorType
			contentType
		}
	}
`;

export const AssetBuildingInfoFragment = gql`
	fragment AssetBuildingInfoFragment on BuildingType {
		address {
			id
			city
			street
			number
			lat
			lng
			zipCode
		}
		buildingsGroup {
			name
		}
		floorAmount
		roomAmount
		zonesAmount
		sensorsAmount
		propertyManagerInfo {
			name
			smallLogoUrl
			managerType
			managerPsId
		}
		facilityManagerInfo {
			name
			smallLogoUrl
			managerType
			managerPsId
		}
		facilityType
		buildingSquareMeters
		constructionYear
	}
`;

export const AssetSensorFragment = gql`
	fragment AssetSensorFragment on SensorBuildingType {
		id
		name
		description
		serialNumber
		sensorType
		location {
			floorName
			roomId
			roomName
		}
		isOnline
		installationDate
	}
`;

export const AssetZoneFragment = gql`
	fragment AssetZoneFragment on ZoneType {
		id
		name
		assets {
			name
			objectId
			contentType
		}
		sensors {
			id
			name
		}
	}
`;

export const AssetInstallationFragment = gql`
	fragment AssetInstallationFragment on RoomType {
		installation {
			id
			name
			description
			sensorManufacturer
			sensorType
			sensorTypeId
			serialNumber
			tags {
				id
				name
			}
			sensorLocationRoom
			sensorLocationFloor
			sensorLocationBuilding
			status
			rssi
		}
		sensors {
			id
		}
	}
`;

export const UpdateLocationMutation = gql`
	mutation CreateOrUpdateBuilding(
		$buildingId: UUID
		$address: GenericScalar
		$name: String
		$squareMeters: Int
		$constructionYear: Int
		$facilityType: FacilityTypeEnum
	) {
		createOrUpdateBuilding(
			buildingId: $buildingId
			address: $address
			name: $name
			squareMeters: $squareMeters
			constructionYear: $constructionYear
			facilityType: $facilityType
		) {
			success
		}
	}
`;

export const UpdateLocationImage = gql`
	mutation CreateOrUpdateBuilding($buildingId: UUID, $file: Upload) {
		createOrUpdateBuilding(buildingId: $buildingId, file: $file) {
			success
			building {
				originalImageUrl
				smallImageUrl
			}
		}
	}
`;

export const CreateOrUpdateBuilding = gql`
	mutation CreateOrUpdateBuilding(
		$buildingId: UUID
		$propertyManagerPsId: UUID
		$propertyManagerType: String
		$facilityManagerPsId: UUID
		$facilityManagerType: String
		$address: GenericScalar
		$name: String
		$file: Upload
		$squareMeters: Int
		$constructionYear: Int
		$facilityType: FacilityTypeEnum
	) {
		createOrUpdateBuilding(
			buildingId: $buildingId
			propertyManagerPsId: $propertyManagerPsId
			propertyManagerType: $propertyManagerType
			facilityManagerPsId: $facilityManagerPsId
			facilityManagerType: $facilityManagerType
			address: $address
			name: $name
			file: $file
			squareMeters: $squareMeters
			constructionYear: $constructionYear
			facilityType: $facilityType
		) {
			success
			building {
				contentType
				floor {
					name
					id
					pk
					contentType
					room {
						contentType
						id
						name
					}
				}
				buildingSquareMeters
				name
				id
			}
		}
	}
`;

export const AssetBuildingsQuery = gql`
	query AssetBuildingsQuery($buildingsId: [UUID], $search: String) {
		buildings(buildingsId: $buildingsId, search: $search) {
			id
			name
			originalImageUrl
			buildingSquareMeters
			constructionYear
			facilityType
			...AssetBuildingInfoFragment
		}
	}

	${AssetBuildingInfoFragment}
`;

export const AssetBuildingFullInfoQuery = gql`
	query AssetBuildingFullInfoQuery($buildingId: [UUID]) {
		buildings(buildingsId: $buildingId) {
			id
			...AssetBuildingInfoFragment
			floor {
				id
				pk
				info
				name
				room {
					id
					name
					roomType
					coordinationMatrix
					...AssetInstallationFragment
				}
				priority
			}
			sensors {
				...AssetSensorFragment
			}
		}
		zones(buildingsId: $buildingId) {
			...AssetZoneFragment
		}
	}
	${AssetBuildingInfoFragment}
	${AssetInstallationFragment}
	${AssetSensorFragment}
	${AssetZoneFragment}
`;

export const AssetBuildingsWithSensorsQuery = gql`
	query AssetBuildingsWithSensorsQuery {
		buildings {
			id
			name
			buildingsGroup {
				name
			}
			floor {
				id
				pk
				room {
					id
					...AssetInstallationFragment
				}
			}
			sensors {
				...AssetSensorFragment
			}
		}
	}
	${AssetSensorFragment}
	${AssetInstallationFragment}
`;

export const AssetSensorLastRequestQuery = gql`
	query AssetSensorLastRequestQuery($serialNumber: String!) {
		sensors(sensorSerialNumber: $serialNumber) {
			lastData {
				capability
				date
				unit
				value
			}
		}
	}
`;

export const AssetRelocateSensorMutation = gql`
	mutation AssetRelocateSensorMutation($roomId: UUID!, $sensorSerialNumber: String!) {
		relocateSensor(roomId: $roomId, sensorSerialNumber: $sensorSerialNumber) {
			success
		}
	}
`;

export const AssetRelocatePlannedSensorMutation = gql`
	mutation AssetRelocatePlannedSensorMutation(
		$installationId: UUID
		$name: String!
		$room: UUID!
		$sensorType: UUID!
		$serialNumber: String!
		$tags: [UUID]!
	) {
		createOrUpdateInstallation(
			installationId: $installationId
			name: $name
			room: $room
			sensorType: $sensorType
			serialNumber: $serialNumber
			tags: $tags
		) {
			success
		}
	}
`;

export const AssetCreateFloorMutation = gql`
	mutation AssetCreateFloorMutation(
		$buildingId: UUID!
		$floorName: String!
		$roomAmount: Int!
	) {
		createFloor(buildingId: $buildingId, floorName: $floorName, roomAmount: $roomAmount) {
			success
			floor {
				id
				pk
				name
				info
				room {
					id
					name
				}
			}
		}
	}
`;

export const AssetFloorNameQuery = gql`
	query AssetFloorNameQuery($floorPk: UUID!) {
		floor(floorId: $floorPk) {
			name
		}
	}
`;

export const AssetFloorNameMutation = gql`
	mutation AssetFloorNameMutation($floorPk: UUID!, $floorName: String!) {
		updateFloor(floorId: $floorPk, floorName: $floorName) {
			floor {
				id
				pk
				name
				priority
			}
			success
		}
	}
`;

export const AssetFloorManagementQuery = gql`
	query AssetFloorManagementQuery($floorPk: UUID!) {
		floor(floorId: $floorPk) {
			id
			pk
			name
			info
			room {
				id
				name
				sensors {
					id
					name
				}
				roomType
			}
		}
	}
`;

export const AssetFloorRoomQuery = gql`
	query AssetFloorManagementQuery($roomId: UUID!) {
		room(roomId: $roomId) {
			organization {
				name
			}
			installation {
				id
				name
				sensorType
				sensorTypeId
				serialNumber
			}
			tenant {
				name
				id
				psId
			}
			sensors {
				contentType
				description
				id
				name
				sensorType
				serialNumber
			}
			zones
			roomType
			name
			id
		}
	}
`;
export const GetOrganizationsTypeQuery = gql`
	query GetOrganizationsTypeQuery {
		organizations {
			id
			name
			psId
			contentType
			type
			typeDisplayName
		}
	}
`;

export const GetOrganizationsQuery = gql`
	query GetOrganizationsQuery($buildingId: UUID, $organizationType: [String]) {
		organizations(buildingId: $buildingId, organizationType: $organizationType) {
			id
			psId
			name
		}
	}
`;

export const AssetZonesQuery = gql`
	query AssetZonesQuery($buildingsId: [UUID]) {
		zones(buildingsId: $buildingsId) {
			...AssetZoneFragment
		}
	}
	${AssetZoneFragment}
`;

export const AssetGetZonesQuery = gql`
	query AssetZonesQuery($zoneId: UUID) {
		zones(zoneId: $zoneId) {
			...AssetZoneFragment
		}
	}
	${AssetZoneFragment}
`;

export const AssetGetZoneInfoQuery = gql`
	query AssetGetZoneInfoQuery($zoneId: UUID) {
		zones(zoneId: $zoneId) {
			id
			name
			assets {
				name
				objectId
				contentType
			}
		}
	}
`;

export const AssetCreateOrUpdateRoomMutation = gql`
	mutation AssetCreateOrUpdateRoomMutation(
		$coordinationMatrix: [Float]
		$floorPk: UUID!
		$roomName: String!
		$roomType: UUID!
		$roomId: UUID
		$tenantOrganizationPsId: UUID
	) {
		createOrUpdateRoom(
			coordinationMatrix: $coordinationMatrix
			floorId: $floorPk
			roomName: $roomName
			roomType: $roomType
			roomId: $roomId
			tenantOrganizationPsId: $tenantOrganizationPsId
		) {
			success
			room {
				id
				name
				sensors {
					id
					name
					serialNumber
				}
				coordinationMatrix: coordinationMatrix
				roomType
			}
		}
	}
`;

export const AssetSensorManufacturersQuery = gql`
	query AssetSensorManufacturersQuery {
		availableSensors
	}
`;

export const AssetSensorInstallationMutation = gql`
	mutation AssetSensorRegisterMutation(
		$installationId: UUID
		$sensorName: String!
		$serialNumber: String!
		$sensorType: UUID!
		$description: String
		$roomId: UUID!
		$tags: [UUID]!
	) {
		createOrUpdateInstallation(
			installationId: $installationId
			name: $sensorName
			serialNumber: $serialNumber
			sensorType: $sensorType
			description: $description
			room: $roomId
			tags: $tags
		) {
			success
			sensorForInstallation {
				id
			}
			rssi
		}
	}
`;

export const AssetFinishSensorInstallationMutation = gql`
	mutation AssetFinishSensorInstallationMutation($file: Upload, $sensors: GenericScalar) {
		finishInstallation(file: $file, sensors: $sensors) {
			success
		}
	}
`;

export const ZoneCreateMutation = gql`
	mutation ZoneCreateMutation($assets: [[String]]!, $zoneName: String!) {
		createOrUpdateZone(assets: $assets, zoneName: $zoneName) {
			success
		}
	}
`;

export const ZoneEditMutation = gql`
	mutation ZoneEditMutation($assets: [[String]]!, $zoneName: String!, $zoneId: UUID) {
		createOrUpdateZone(assets: $assets, zoneName: $zoneName, zoneId: $zoneId) {
			success
		}
	}
`;

export const AddressInUse = gql`
	query AddressInUse($address: BuildingAddressInput!) {
		addressInUse(address: $address)
	}
`;
